import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { IconContent } from './components/IconContent/IconContent.js';
import { IconLoadingContainer } from './components/IconLoadingContainer/IconLoadingContainer.js';
import { useIcon } from './hooks/useIcon.js';
import { TypographySizeContainer } from '../TypographySizeContainer/TypographySizeContainer.js';

var LoadingContainer = function LoadingContainer(props) {
  var loadingContainerProps = props.loadingContainerProps,
    children = props.children;
  if (!loadingContainerProps) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(IconLoadingContainer, loadingContainerProps, children);
};
var InlineContainer = function InlineContainer(props) {
  var inlineContainerProps = props.inlineContainerProps,
    children = props.children;
  if (!inlineContainerProps) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(TypographySizeContainer, inlineContainerProps, children);
};
var IconV3 = function IconV3(props) {
  var content = useIcon(props);
  return /*#__PURE__*/React.createElement("span", _extends({
    role: "img"
  }, content.componentContainerStyle), /*#__PURE__*/React.createElement(InlineContainer, content, /*#__PURE__*/React.createElement(LoadingContainer, content, /*#__PURE__*/React.createElement(IconContent, content.iconContentProps))));
};
var IconV3Memoized = /*#__PURE__*/React.memo(IconV3);
IconV3Memoized.displayName = 'IconV3';

export { IconV3Memoized as IconV3 };
//# sourceMappingURL=Icon.js.map
